import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth.js';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './App.css';

msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .then(() => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </BrowserRouter>
      </React.StrictMode>
    );
  })
  .catch((err) => {
    console.error("MSAL bootstrap failed:", err);
  });



serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Custom event to notify React that there's an update
    const event = new CustomEvent('swUpdated', { detail: registration });
    window.dispatchEvent(event);
  },
});